import React from 'react';
import { FaShoppingBag, FaCommentAlt } from 'react-icons/fa';
import { IoCheckmarkCircle } from 'react-icons/io5';
import { FiDollarSign } from 'react-icons/fi';
import type { HowItWorksStep } from './types';

export const HOW_IT_WORKS_STEPS: HowItWorksStep[] = [
  {
    title: 'Set your rates',
    body: 'Build packages so brands can see exactly what you offer.',
    Icon: ({ size = 14 }) => <FiDollarSign size={size} />,
  },
  {
    title: 'Brand places an order',
    body: 'A local brand buys a package directly from your profile.',
    Icon: ({ size = 14 }) => <FaShoppingBag size={size} />,
  },
  {
    title: 'You accept',
    body: "Review the brief and accept when you're ready.",
    Icon: ({ size = 16 }) => <IoCheckmarkCircle size={size} />,
  },
  {
    title: 'Coordinate in inbox',
    body: 'Chat, submit, and get paid — all in one place.',
    Icon: ({ size = 14 }) => <FaCommentAlt size={size} />,
  },
];
